import React from 'react';
import PropTypes from 'prop-types';

const ContentExperencieLenguages = ({Title, Img, Width}) => (
    <article className="content-thecnology-or-lenguages">
        <p className="image-container-experience">
            <img src={Img} alt={Title} className="img-thecnology" />
        </p>
        <h3 className="title-thecnology"> {Title} </h3>
        <section className="percentage-container">
            <article className="content-width-container">
                <div className="percentage-width" style={{width: `${Width}%` }}></div>
            </article>
            <p style={{margin: "0px"}} className="width-notation">{Width}% </p>
        </section>
    </article>
)

ContentExperencieLenguages.propTypes = {
    Title: PropTypes.string,
    Img: PropTypes.string,
    Width: PropTypes.string
}

ContentExperencieLenguages.defaultProps = {
    Title: "Tecnologia",
    Img: "",
    Width: "0"
}

export default ContentExperencieLenguages;
